import { render, staticRenderFns } from "./CAxAFAxFamiliarPt2Page.vue?vue&type=template&id=54672e9d"
import script from "./CAxAFAxFamiliarPt2Page.vue?vue&type=script&lang=js"
export * from "./CAxAFAxFamiliarPt2Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports